module.exports = __webpack_public_path__ + "img/client6.762c5de0.svg";